import { render, staticRenderFns } from "./MatrixDeadlineCard.vue?vue&type=template&id=229e4d40"
import script from "./MatrixDeadlineCard.vue?vue&type=script&lang=js"
export * from "./MatrixDeadlineCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports